
import { motion } from 'framer-motion';

export default function HeroSection() {
  return (
    <section className="relative h-screen w-full overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/c1090070f0668047697fd540c1f40d7c.jpg"
          alt="Industrial Excellence"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/40 to-black/70"></div>
      </div>

      <div className="relative z-10 h-full flex items-center justify-center">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 text-center w-full">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 1, delay: 0.3 }}
          >
            <h1
              className="text-3xl sm:text-5xl md:text-7xl font-bold text-white mb-4 sm:mb-6 tracking-tight leading-tight"
              style={{ fontFamily: 'Rajdhani, sans-serif' }}
            >
              Zaawansowane<br />
              <span className="text-[#00E5FF]">Konstrukcje Stalowe</span><br />
              dla Przemysłu
            </h1>
          </motion.div>

          <motion.p
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 1, delay: 0.6 }}
            className="text-base sm:text-xl md:text-2xl text-[#C0C7CF] mb-8 sm:mb-12 tracking-wide px-2"
            style={{ fontFamily: 'Inter, sans-serif', fontWeight: 300 }}
          >
            Precyzja. Technologia. Niezawodność od 1989 roku.
          </motion.p>

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 1, delay: 0.9 }}
            className="flex flex-col sm:flex-row gap-3 sm:gap-6 justify-center items-center px-4 sm:px-0"
          >
            <a
              href="#kontakt"
              className="group relative w-full sm:w-auto px-8 sm:px-10 py-4 sm:py-5 bg-[#00E5FF] text-[#050505] font-bold text-sm sm:text-lg overflow-hidden transition-all duration-300 hover:scale-105 whitespace-nowrap cursor-pointer text-center"
              style={{ fontFamily: 'Orbitron, sans-serif' }}
            >
              <span className="relative z-10">Rozpocznij współpracę</span>
              <div className="absolute inset-0 bg-white transform scale-x-0 group-hover:scale-x-100 transition-transform duration-300 origin-left"></div>
            </a>

            <a
              href="#uslugi"
              className="group w-full sm:w-auto px-8 sm:px-10 py-4 sm:py-5 border-2 border-[#00E5FF] text-[#00E5FF] font-bold text-sm sm:text-lg transition-all duration-300 hover:bg-[#00E5FF] hover:text-[#050505] whitespace-nowrap cursor-pointer text-center"
              style={{ fontFamily: 'Orbitron, sans-serif' }}
            >
              Poznaj możliwości
            </a>
          </motion.div>
        </div>
      </div>

      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 1, delay: 1.5 }}
        className="absolute bottom-8 sm:bottom-12 left-1/2 transform -translate-x-1/2 z-20"
      >
        <motion.div
          animate={{ y: [0, 10, 0] }}
          transition={{ duration: 2, repeat: Infinity }}
          className="w-8 h-8 flex items-center justify-center cursor-pointer"
        >
          <i className="ri-arrow-down-line text-2xl sm:text-3xl text-[#00E5FF]"></i>
        </motion.div>
      </motion.div>
    </section>
  );
}
